<template>
  <div class="columns">
    <div class="column is-12-desktop is-mobile form-column">
      <div class="change-password-box is-narrow">
        <div class="sections-flex-wrapper" v-if="!passwordChanged.success">
          <section class="form-section form-primary-section">
            <h2 class="heading-2 header-marker" v-if="$mq.desktop">{{ fieldLabel }}</h2>
            <h3 class="heading-3 header-marker" v-else>{{ fieldLabel }}</h3>
            <p>{{ helpText }}</p>
            <change-password-form-component
              :hasPassword="hasPassword"
              :error="error"
              :password="password"
              :handlePasswordChange="handlePasswordChange"
              :handleChangeNewPassword="handleChangeNewPassword">
            </change-password-form-component>
          </section>
        </div>
        <change-password-success-component v-else :message="passwordChanged.detail"></change-password-success-component>
      </div>
    </div>
  </div>
</template>

<script>
import ChangePasswordFormComponent from '@/pages/change-password/ChangePasswordFormComponent';
import ChangePasswordSuccessComponent from '@/pages/change-password/ChangePasswordSuccessComponent';
import {mapGetters} from 'vuex';

export default {
  props: {
    passwordChanged: Object,
    error: Object,
    handleChangeNewPassword: Function,
    handlePasswordChange: Function,
    password: String
  },
  computed: {
    ...mapGetters([
      'userState',
    ]),
    hasPassword() {
      return this.userState.details.has_password;
    },
    fieldLabel(){
      return this.hasPassword ? this.$gettext('Change password') : this.$gettext('Create password')
    },
    helpText(){
      return this.hasPassword ? 
        this.$gettext('Enter your new password. After that you can login with it.') :
        this.$gettext('Please use the field below to create your password.');
    },
  },
  components: {
    ChangePasswordFormComponent,
    ChangePasswordSuccessComponent
  }
};
</script>

<style scoped lang="scss">
@import '~VariablesStyles';
.header-marker {
  margin-bottom: 15px;
}
.form-column {
  align-items: center;
  justify-content: center;
}
footer {
  width: 100%;
}
.change-password-box {
  width: 100%;
  max-width: 320px;
  margin: 65px auto 0;
}
@media screen and (min-width: $tablet) {
  footer {
    position: absolute;
    width: 100%;
    margin-top: 0;
    bottom: 0;
  }
  .change-password-box {
    margin: 0;
  }
}
</style>
